<div style="padding:30px">

    <ul class="nav nav-tabs" style="margin: 0 0 15px 0">
        <li *ngFor="let item of menu_list" class="nav-item" (click)="tab = item.id">
            <span style="cursor:pointer" [ngClass]="tab == item.id ? 'active' : ''" class="nav-link">{{item.name}}</span>
        </li>
    </ul>

    <!-- 活動清單 -->
    <div *ngIf="tab == 'rank'">
    <div class="tips" style="margin-bottom:10px;">
        這裡只能編輯活動底下的「等級」。活動本身的新增／複製／期間設定仍在「稱號設定」那一頁。<br>
        已經有用戶紀錄的等級不可刪除（刪掉會讓那些紀錄找不到等級，App 端稱號會直接消失），但可以改名稱、門檻與頭像框。
    </div>
    <table class="table table-responsive-sm" *ngIf="rank_list.length>0">
        <thead>
        <tr class="table-primary" style="font-size:18px;">
            <th style="width:6%">id</th>
            <th style="width:24%">活動名稱</th>
            <th style="width:6%">性別</th>
            <th style="width:6%">類型</th>
            <th style="width:20%">計算期間</th>
            <th style="width:8%">等級數</th>
            <th style="width:10%">用戶紀錄數</th>
            <th style="width:10%">操作</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let item of rank_list">
            <td>{{item.id}}</td>
            <td>{{item.name}}</td>
            <td>{{gender_name(item.gender)}}</td>
            <td>{{item.type}}</td>
            <td>{{item.start_count_date}} ~ {{item.dead_line_date}}</td>
            <td>{{(item.detail || []).length}}</td>
            <td>{{rank_used(item)}}</td>
            <td>
                <button class="btn btn-primary" (click)="open_lv_edit(item)"
                    data-toggle="modal" data-target=".bd-lv-edit-modal">編輯等級</button>
            </td>
        </tr>
        </tbody>
    </table>
    <div *ngIf="rank_list.length==0" class="tips" style="padding:15px;">目前沒有任何活動。</div>
    </div>


    <!-- 稱號紀錄 -->
    <div *ngIf="tab == 'record'">

    <!-- 搜尋列 -->
    <div class="form-row" style="margin-bottom:15px;align-items:flex-end;">
        <div class="col-sm-2">
            <label class="col-form-label">uid / 電話</label>
            <input type="text" [(ngModel)]="search.keyword" (keyup.enter)="do_search()"
                placeholder="完整 uid 或電話" class="form-control">
        </div>
        <div class="col-sm-2">
            <label class="col-form-label">稱號</label>
            <select [(ngModel)]="search.user_rank_id" class="form-control">
                <option [ngValue]="-1">全部</option>
                <option *ngFor="let item of rank_list" [ngValue]="item.id">{{item.name}}</option>
            </select>
        </div>
        <div class="col-sm-2">
            <label class="col-form-label">狀態</label>
            <select [(ngModel)]="search.status" class="form-control">
                <option [ngValue]="-1">全部</option>
                <option *ngFor="let item of status_list" [ngValue]="item.id">{{item.name}}</option>
            </select>
        </div>
        <div class="col-sm-2">
            <label class="col-form-label">來源</label>
            <select [(ngModel)]="search.is_manual" class="form-control">
                <option [ngValue]="-1">全部</option>
                <option *ngFor="let item of source_list" [ngValue]="item.id">{{item.name}}</option>
            </select>
        </div>
        <div class="col-sm-1" style="padding-top:10px;">
            <button class="btn btn-secondary" (click)="do_search()">搜尋</button>
        </div>
        <div class="col-sm-3" style="padding-top:10px;text-align:right;">
            <button class="btn btn-primary" (click)="init_give_data()"
                data-toggle="modal" data-target=".bd-give-title-modal">手動給予稱號</button>
        </div>
    </div>

    <div class="tips" style="margin-bottom:10px;">
        這頁列出全部稱號紀錄，「來源」欄可分辨是後台手動給予還是排程自動計算的。<br>
        手動給予的稱號會脫離排程控管：該用戶的這個稱號不會再被自動升級或降級，直到收回為止。排程自動的紀錄不能從這頁收回。
    </div>

    <!-- 列表 -->
    <table style="margin-top: 10px;" class="table table-responsive-sm" *ngIf="!loading && data.length>0">
        <thead>
        <tr class="table-primary" style="font-size:18px;">
            <th style="width:8%">uid</th>
            <th style="width:10%">暱稱</th>
            <th style="width:10%">電話</th>
            <th style="width:10%">稱號</th>
            <th style="width:10%">等級名稱</th>
            <th style="width:6%">狀態</th>
            <th style="width:8%">來源</th>
            <th style="width:8%">操作員</th>
            <th style="width:12%">備註</th>
            <th style="width:10%">建立時間</th>
            <th style="width:6%">操作</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let item of data" class="{{(item.status!=1)?'table-secondary':''}}">
            <td>{{item.uid}}</td>
            <td>{{item.user_name}}</td>
            <td>{{item.phone_num}}</td>
            <td>{{item.rank_name}}</td>
            <td>{{item.lv_name}}</td>
            <td>{{status_name(item.status)}}</td>
            <td>{{source_name(item.is_manual)}}</td>
            <td>{{(item.is_manual==1) ? item.admin_name : '—'}}</td>
            <td>{{item.remark}}</td>
            <td>{{item.create_dt}}</td>
            <td>
                <!-- 只有手動給予的紀錄能收回，排程的紀錄後端也會擋 -->
                <button *ngIf="item.status==1 && item.is_manual==1" (click)="cancel(item)" class="btn btn-danger">收回</button>
            </td>
        </tr>
        </tbody>
    </table>
    <div *ngIf="loading" style="padding:20px 0;">查詢中...</div>

    <!-- 查無資料：說明「為什麼沒有」，不要只寫無資料 -->
    <div *ngIf="!loading && data.length==0" class="tips" style="padding:15px;">
        {{empty_msg()}}
    </div>

    <app-pagnation *ngIf="data.length>0" (callback)="callback($event)" [data]="pageobjstr"></app-pagnation>
    </div>


    <!-- 兩個 modal 都放在頁籤外面：放在頁籤裡的話切換頁籤會把 modal 從 DOM 移除 -->

    <!-- 等級編輯 -->
    <div class="modal fade bd-lv-edit-modal" tabindex="-1"
        role="dialog" data-keyboard="false" data-backdrop="static"
        aria-hidden="true" style="max-height: 700px;overflow:auto;">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">編輯等級{{edit_rank ? '：' + edit_rank.name : ''}}</h5>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div style="padding: 10px;" *ngIf="edit_rank">

                    <button class="btn btn-primary" (click)="add_lv()" style="margin-bottom:10px;">新增等級</button>

                    <table class="table table-responsive-sm">
                        <thead>
                        <tr class="table-primary">
                            <th style="width:18%">等級名稱</th>
                            <th style="width:12%">門檻</th>
                            <th style="width:12%">一次性獎勵</th>
                            <th style="width:10%">是否計算</th>
                            <th style="width:28%">頭像框圖片網址</th>
                            <th style="width:10%">用戶紀錄</th>
                            <th style="width:10%">操作</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let item of edit_lv_list; let i = index">
                            <td><input type="text" [(ngModel)]="item.name" class="form-control"></td>
                            <td><input type="number" [(ngModel)]="item.threshold" class="form-control"></td>
                            <td><input type="number" [(ngModel)]="item.once_reward" class="form-control"></td>
                            <td>
                                <button [ngClass]="item.real_info==1?'btn-danger':'btn-secondary'"
                                    (click)="item.real_info=1" class="btn">是</button>
                                <button [ngClass]="item.real_info==0?'btn-danger':'btn-secondary'"
                                    (click)="item.real_info=0" class="btn">否</button>
                            </td>
                            <td>
                                <input type="text" [(ngModel)]="item.frame" class="form-control"
                                    placeholder="留空代表此等級沒有頭像框">
                            </td>
                            <td>{{item.used_count}}</td>
                            <td>
                                <button *ngIf="item.used_count*1==0" (click)="del_lv(i)" class="btn btn-danger">刪除</button>
                                <button *ngIf="item.used_count*1>0" class="btn btn-secondary" disabled>刪除</button>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <div class="tips" style="margin-top:10px;">
                        「是否計算」選否的是純說明列，排程不會用它判斷等級。<br>
                        真實等級的門檻不可重複 —— 排程是照門檻由大到小取第一個符合的區間，門檻相同會讓判斷結果不確定。<br>
                        儲存後會依門檻由小到大重新編號 lv。頭像框目前只有「官方儲值」那個活動的等級會被 App 讀取。
                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">取消</button>
                    <button type="button" class="btn btn-primary" (click)="save_lv()">儲存</button>
                </div>
            </div>
        </div>
    </div>


    <!-- 給予稱號 -->
    <div class="modal fade bd-give-title-modal" tabindex="-1"
        role="dialog" data-keyboard="false" data-backdrop="static"
        aria-hidden="true" style="max-height: 650px;overflow:auto;">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">手動給予稱號</h5>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div style="padding: 10px;">

                    <div class="user_edit_block">
                        <label class="col-sm-2 col-form-label">uid / 電話</label>
                        <input type="text" [(ngModel)]="give_data.keyword"
                            placeholder="完整 uid 或完整電話" class="form-control">
                        <div style="margin-top:10px;" class="tips offset-sm-2">
                            這裡是完全比對，電話要填完整。若同一組號碼有多個國碼的用戶，會請你改用 uid 指定。
                        </div>
                    </div>

                    <div class="user_edit_block">
                        <label class="col-sm-2 col-form-label">稱號</label>
                        <select [(ngModel)]="give_data.user_rank_id" (change)="ck_lv_list()" class="form-control">
                            <option [ngValue]="-1">請選擇</option>
                            <option *ngFor="let item of rank_list" [ngValue]="item.id">{{item.name}}</option>
                        </select>
                    </div>

                    <div class="user_edit_block">
                        <label class="col-sm-2 col-form-label">等級</label>
                        <select [(ngModel)]="give_data.user_rank_lv_id" class="form-control">
                            <option [ngValue]="-1">請選擇</option>
                            <option *ngFor="let item of lv_option_list" [ngValue]="item.id">
                                {{item.name}}（門檻 {{item.threshold}}）
                            </option>
                        </select>
                        <div *ngIf="give_data.user_rank_id!=-1 && lv_option_list.length==0"
                            style="margin-top:10px;" class="tips offset-sm-2">此稱號底下沒有可用的等級</div>
                    </div>

                    <div class="user_edit_block">
                        <label class="col-sm-2 col-form-label">備註</label>
                        <input type="text" [(ngModel)]="give_data.remark" placeholder="給予原因（選填）" class="form-control">
                    </div>

                    <div style="margin-top: 10px;" class="tips">
                        給予後，該用戶原本這個稱號的生效紀錄會被下架，並改由這筆手動紀錄生效。
                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">取消</button>
                    <button type="button" class="btn btn-primary" (click)="give()">確定給予</button>
                </div>
            </div>
        </div>
    </div>

</div>
